const variable = {
    LINK_API : 'https://stageapifinance.cekgudang.com/', // dev
    // LINK_API : 'http://localhost:8000/' // local
    // LINK_API : 'http://192.168.0.116:8000/' // with ip
}

export default variable

